import { ChangeCashMode } from './model';
import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Iconify, Stack, Typography } from '@pflegenavi/web-components';
import { LetterChip } from './LetterChip';
import { useFeatureFlagEnabled } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag } from '@pflegenavi/shared/api';

interface ChangeCashFormStep1Props {
  nextStep: () => void;
  setMode: (mode: ChangeCashMode) => void;
}

export const ChangeCashFormStep1: FC<ChangeCashFormStep1Props> = ({
  nextStep,
  setMode,
}) => {
  const { t } = useTranslation();
  const hideDeposit = useFeatureFlagEnabled(
    FeatureFlag.HideCashManagementDeposit
  );

  return (
    <Stack direction="column" gap={1} sx={{ paddingY: 1 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <LetterChip>A</LetterChip>
        <Typography variant="h6" fontWeight={700}>
          {hideDeposit
            ? t('cashManagement.withdraw')
            : `${t('cashManagement.deposit')} / ${t(
                'cashManagement.withdraw'
              )}`}
        </Typography>
      </Stack>

      <Typography variant="body1">
        {t(
          hideDeposit
            ? 'cashManagement.withdraw-only'
            : 'cashManagement.deposit-or-withdraw'
        )}
      </Typography>

      <Stack direction="row" gap={1} justifyContent="end">
        <Button
          name={'changeCashWithdraw'}
          sx={{ width: 140 }}
          variant="contained"
          color="error"
          endIcon={<Iconify icon="eva:trending-down-fill" />}
          onClick={() => {
            setMode(ChangeCashMode.Withdraw);
            nextStep();
          }}
        >
          {t('cashManagement.withdraw')}
        </Button>

        {!hideDeposit && (
          <Button
            name={'changeCashDeposit'}
            sx={{ width: 140 }}
            variant="contained"
            endIcon={<Iconify icon="eva:trending-up-fill" />}
            onClick={() => {
              setMode(ChangeCashMode.Deposit);
              nextStep();
            }}
          >
            {t('cashManagement.deposit')}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
